/**
 * Created by Jerker Nord on 2021-01-27.
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class SerialGameAssets {

    static DEFAULT_TEXTSTYLE_PLACEHOLDER = new PIXI.TextStyle({
        fill : 0xff0000,
        fontFamily : OpenSans.FAMILY,
        wordWrap : false,
        fontWeight : FontWeight.BOLD,
        fontSize : 50
    })

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "CountUp_Font_Maingame";
    static BITMAP_FONT_NUDGE_MULTIPLIER = "Nudge_Multiplier";
    static BITMAP_FONT_SCATTER = "Font_Scatter";
    static BITMAP_FONT_WAYS = "Font_Ways";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FS_GAME_BACKGROUND:string = "FS_Background";
    public static FS_SUPER_GAME_BACKGROUND:string = "Super_FS_Background";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],

        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset(SerialGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(SerialGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/CountUp_Font_Maingame.fnt"),
                    new BitmapFontAsset(SerialGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER, "fonts/bitmapfonts/Nudge_Multiplier.fnt"),
                    new BitmapFontAsset(SerialGameAssets.BITMAP_FONT_SCATTER, "fonts/bitmapfonts/Font_Scatter.fnt"),
                    new BitmapFontAsset(SerialGameAssets.BITMAP_FONT_WAYS, "fonts/bitmapfonts/Font_Ways.fnt")
                ]
            },
            {
                name : "mainHigh",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHigh0", "sheets/mainHigh/mainHigh0.json")
                ],
                animations : {}
            },
            {
                name : "backgrounds",
                assets : [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json"),
                    new TextureAsset("backgroundsJpeg4", "sheets/backgroundsJpeg/backgroundsJpeg4.json")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                    new TextureAsset("main9", "sheets/main/main9.json"),
                    new TextureAsset("mainNocompression0", "sheets/main/mainNocompression0.json"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpegSparks0", "sheets/mainJpeg/mainJpegSparks0.json"),
                    new TextureAsset("mainJpegSparks1", "sheets/mainJpeg/mainJpegSparks1.json"),
                    new TextureAsset("mainJpegSparks2", "sheets/mainJpeg/mainJpegSparks2.json"),
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbolsJpeg0", "sheets/symbols/symbolsJpeg0.json")
                ],
                animations : {}
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("bigWinL1", "spine/bigwin/BigWinSequence01.json"),
                    new SpineAsset("bigWinL2", "spine/bigwin/BigWinSequence02.json"),
                    new SpineAsset("bigWinL3", "spine/bigwin/BigWinSequence03.json"),
                    new SpineAsset("bigWinL4", "spine/bigwin/BigWinSequence04.json"),
                    new SpineAsset("bigWinL5", "spine/bigwin/BigWinSequence05.json"),
                    new SpineAsset("bigWinNearWin", "spine/bigwin/nearWin_BW.json"),
                    new SpineAsset("sfsIntro", "spine/fsintro/SFSIntro.json"),
                    new SpineAsset("fsIntro", "spine/fsintro/FSIntro.json"),
                    new SpineAsset("fsTransition", "spine/fsintro/FSTransition.json"),
                    new SpineAsset("xBet", "spine/xbet/XBETLampfeatureSpine.json"),
                    new SpineAsset("waysLandscape", "spine/ways/ways_landscape.json"),
                    new SpineAsset("waysPortrait", "spine/ways/ways_portrait.json"),
                    new SpineAsset("xNudge", "spine/xnudge.json"),
                    new SpineAsset("xNudgeEnhancer", "spine/WXN_enhancer.json"),
                    new SpineAsset("wild", "spine/wild.json"),
                    new SpineAsset("bg", "spine/bg.json"),
                    new SpineAsset("initialWin", "spine/initialWin.json"),
                    new SpineAsset("S2", "spine/xsplit/S2.json"),
                    new SpineAsset("xSplit", "spine/xsplit/xSplit.json"),
                    new SpineAsset("bgCutting", "spine/xsplit/bgCutting.json"),
                    new SpineAsset("S1", "spine/S1.json"),
                    new SpineAsset("winCap1", "spine/wincap/WC_LEVEL01.json"),
                    new SpineAsset("winCap2", "spine/wincap/WC_LEVEL02.json"),
                    new SpineAsset("winCap3", "spine/wincap/WC_LEVEL03.json"),
                    new SpineAsset("nearWinBack", "spine/nearwin/BGanticipation.json"),
                    new SpineAsset("nearWinFore", "spine/nearwin/SCanticipation.json"),
                    new SpineAsset("S1ToXways", "spine/S1toXway.json"),
                    new SpineAsset("infectious", "spine/infectious.json")
                ]
            }
        ]
    };
}